// West Africa French (WAF) region — Fortinet sales coverage.
// Names match the GeoJSON `properties.name` field of the bundled Africa
// TopoJSON (Natural Earth 1:110m). Two micro-states are not represented in
// the 110m dataset (Cabo Verde, São Tomé & Príncipe) and are rendered as
// off-shore island markers in the map page.
export const WAF_COUNTRIES = [
  { name: "Côte d'Ivoire",      label: "Côte d'Ivoire",         iso2: "CI", capital: "Abidjan",   onMap: true,  coords: [-5.55, 6.85] },
  { name: "Mali",               label: "Mali",                  iso2: "ML", capital: "Bamako",    onMap: true,  coords: [-4.0, 17.5]  },
  { name: "Burkina Faso",       label: "Burkina Faso",          iso2: "BF", capital: "Ouagadougou", onMap: true, coords: [-1.5, 12.4] },
  { name: "Niger",              label: "Niger",                 iso2: "NE", capital: "Niamey",    onMap: true,  coords: [8.0, 17.6]   },
  { name: "Togo",               label: "Togo",                  iso2: "TG", capital: "Lomé",      onMap: true,  coords: [1.0, 8.5]    },
  { name: "Benin",              label: "Bénin",                 iso2: "BJ", capital: "Porto-Novo", onMap: true, coords: [2.4, 9.5]    },
  { name: "Gabon",              label: "Gabon",                 iso2: "GA", capital: "Libreville", onMap: true, coords: [11.6, -0.8] },
  { name: "Guinea-Bissau",      label: "Guinée-Bissau",         iso2: "GW", capital: "Bissau",    onMap: true,  coords: [-15.0, 12.0] },
  { name: "Guinea",             label: "Guinée",                iso2: "GN", capital: "Conakry",   onMap: true,  coords: [-10.5, 10.5] },
  { name: "Eq. Guinea",         label: "Guinée Équatoriale",    iso2: "GQ", capital: "Malabo",    onMap: true,  coords: [10.3, 1.5]   },
  // Off-shore islands rendered as map markers (no polygon in the 110m world atlas)
  { name: "Cabo Verde",         label: "Cap-Vert",              iso2: "CV", capital: "Praia",     onMap: false, coords: [-23.5, 16.0] },
  { name: "Sao Tome",           label: "São Tomé-et-Príncipe",  iso2: "ST", capital: "São Tomé",  onMap: false, coords: [6.7, 0.3]    },
];

export const WAF_COUNTRY_NAMES = new Set(WAF_COUNTRIES.map((c) => c.name));

// Roster of Fortinet field engineers covering WAF — shared across countries.
// Email pattern follows the Fortinet standard `<initial><lastname>@fortinet.com`
// confirmed for the Mali team; emails inferred for other team members can be
// edited here if the standard differs in practice.
const ROSTER = {
  philippe:   { name: "Philippe Diogo",       phone: "",                    email: "Pdiogo@fortinet.com" },
  alioune:    { name: "Alioune Dieng",        phone: "+225 07 58 44 86 67", email: "adieng@fortinet.com" },
  nadine:     { name: "Nadine Dosso",         phone: "+225 07 08 01 70 95", email: "ndosso@fortinet.com" },
  lucien:     { name: "Lucien Davo",          phone: "+225 07 57 58 26 01", email: "ldavo@fortinet.com" },
  sekou:      { name: "Sekou Diomandé",       phone: "+225 07 09 93 03 80", email: "sdiomande@fortinet.com" },
  melissa:    { name: "Melissa Ablé",         phone: "+225 07 07 10 47 48", email: "mable@fortinet.com" },
  richard:    { name: "Richard Zougou",       phone: "+225 04 79 46 832",   email: "rzougou@fortinet.com" },
  cheick:     { name: "Cheick Koita",         phone: "+225 07 11 10 64 75", email: "ckoita@fortinet.com" },
  drissa:     { name: "Drissa Doumbia",       phone: "+225 07 77 82 72 75", email: "ddoumbia@fortinet.com" },
  mouanzedine: { name: "Mouanzedine Adekpedjou", phone: "+225 05 65 81 23 75", email: "madekpedjou@fortinet.com" },
  abdoulahi:  { name: "Abdoulahi Ly",         phone: "+225 07 59 12 64 13", email: "aly@fortinet.com" },
  emeline:    { name: "Emeline Kouame",       phone: "+225 07 48 08 52 58", email: "ekouame@fortinet.com" },
};

const C = (key, role) => ({ ...ROSTER[key], role, linkedin: "" });

// Country-specific Account Managers + technical team — shown in the "Selected
// country" card. Last update: 2026-04-30 (full WAF roster).
export const WAF_COUNTRY_AMS = {
  // Côte d'Ivoire — siège régional, équipe complète présente.
  "Côte d'Ivoire": [
    C("alioune", "Major Account Manager"),
    C("sekou",   "Major Account Manager"),
    C("melissa", "Major Account Manager"),
    C("nadine",  "Regional Account Manager"),
    C("lucien",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
    C("drissa",  "System Engineer"),
    C("mouanzedine", "System Engineer"),
  ],
  Mali: [
    C("alioune", "Major Account Manager"),
    C("nadine",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
  ],
  Benin: [
    C("alioune", "Major Account Manager"),
    C("lucien",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
    C("drissa",  "System Engineer"),
  ],
  Togo: [
    C("alioune", "Major Account Manager"),
    C("lucien",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
    C("drissa",  "System Engineer"),
  ],
  Guinea: [
    C("sekou",   "Major Account Manager"),
    C("nadine",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
    C("mouanzedine", "System Engineer"),
  ],
  "Guinea-Bissau": [
    C("sekou",   "Major Account Manager"),
    C("nadine",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
    C("mouanzedine", "System Engineer"),
  ],
  "Burkina Faso": [
    C("sekou",   "Major Account Manager"),
    C("nadine",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
    C("mouanzedine", "System Engineer"),
  ],
  Niger: [
    C("sekou",   "Major Account Manager"),
    C("nadine",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
    C("mouanzedine", "System Engineer"),
  ],
  Gabon: [
    C("melissa", "Major Account Manager"),
    C("lucien",  "Regional Account Manager"),
    C("cheick",  "Presales Lead"),
    C("drissa",  "System Engineer"),
  ],
  "Eq. Guinea": [
    C("melissa", "Major Account Manager"),
    C("lucien",  "Regional Account Manager"),
    C("cheick",  "Presales Lead"),
    C("drissa",  "System Engineer"),
  ],
  "Cabo Verde": [
    C("melissa", "Major Account Manager"),
    C("nadine",  "Regional Account Manager"),
    C("richard", "System Engineer"),
    C("cheick",  "Presales Lead"),
    C("drissa",  "System Engineer"),
  ],
  // São Tomé-et-Príncipe — même couverture que Gabon.
  "Sao Tome": [
    C("melissa", "Major Account Manager"),
    C("lucien",  "Regional Account Manager"),
    C("cheick",  "Presales Lead"),
    C("drissa",  "System Engineer"),
  ],
};

// Real WAF team — last update 2026-05-04.
// Country leadership at the top, full field roster grouped by role, and a
// dedicated Channel & Renewal sub-team at the bottom.
export const WAF_TEAM = {
  region: {
    name: "West Africa French (WAF)",
    slug: "WAF",
    timezone: "GMT / GMT+1",
    headquarters: "Abidjan, Côte d'Ivoire",
  },
  // Highlighted at the top of the contacts card
  countryManager: {
    role: "Country Manager",
    ...ROSTER.philippe,
  },
  // Full field roster — Major/Regional Account Managers + System Engineers
  contacts: [
    { role: "Major Account Manager", ...ROSTER.alioune },
    { role: "Major Account Manager", ...ROSTER.sekou },
    { role: "Major Account Manager", ...ROSTER.melissa },
    { role: "Regional Account Manager", ...ROSTER.nadine },
    { role: "Regional Account Manager", ...ROSTER.lucien },
    { role: "Presales Lead", ...ROSTER.cheick },
    { role: "System Engineer", ...ROSTER.richard },
    { role: "System Engineer", ...ROSTER.drissa },
    { role: "System Engineer", ...ROSTER.mouanzedine },
  ],
  // Channel & Renewal team — rendered as a separate section at the bottom
  channelRenewal: [
    { role: "Channel Account Manager", ...ROSTER.abdoulahi },
    { role: "ISR Renewal", ...ROSTER.emeline },
  ],
};
